import { render, staticRenderFns } from "./options.configurator.vue?vue&type=template&id=703b48b8&"
import script from "./options.configurator.vue?vue&type=script&lang=ts&"
export * from "./options.configurator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports